/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

const formatRegExp = /^(?<format>video|image)\//;

const getFormat = (srcType) => {
    if (srcType) {
        const match = srcType.match(formatRegExp);
        if (match) return match.groups.format;
    }
};

export default getFormat;
